import { Expose, Type } from 'class-transformer'

import { BookmarkBookType } from './BookmarkBookType'

export class BookmarkChapterType {
  @Expose() id: number

  @Expose() chapterName: string

  @Expose()
  @Type(() => BookmarkBookType)
  book: BookmarkBookType
}
